exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".organization-users-page{padding:10px}.organization-users-page .add-organization-user{margin-bottom:10px}", ""]);

// exports
